import React from 'react';

import { SearchResultFacetGroup } from '@reverbdotcom/commons/src/gql/graphql';
import { RCChip } from '@reverbdotcom/cadence/components';
import { withRouter, WithRouterProps } from 'react-router';
import { allSelectedFacets } from './facet';

type FacetChipRowProps = {
  facetGroups?: SearchResultFacetGroup[];
} & WithRouterProps;

export function FacetChipRow({ facetGroups = [], router }: FacetChipRowProps) {
  const facetChips = allSelectedFacets(facetGroups);

  return (
    <div className="scroll-x-on-tablet scroll-x-on-tablet--full-bleed">
      <RCChip.Collection nowrap="tablet">
        {facetChips.map((chip, idx) => {
          return (
            <RCChip
              data-testid="mobile-facet-chip"
              selected
              onClick={() => { router.replace(chip.searchUrl); }}
              key={`mobile-facet-chip-${chip.displayName}-${idx}`}
            >
              {chip.displayName}
            </RCChip>
          );
        })}
      </RCChip.Collection>
    </div>
  );
}

export default withRouter(FacetChipRow);
